const trustAsResourceUrlFilter = function ($sce) {
  'ngInject'
  return function (val) {
    return $sce.trustAsResourceUrl(val)
  }
}
export default trustAsResourceUrlFilter
